// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R2shortAiAlternativeRouteImport } from './routes/2short-ai-alternative'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AdcreativeAiAlternativeRouteImport } from './routes/adcreative-ai-alternative'
import { Route as AppRouteImport } from './routes/app'
import { Route as GameplayFacecamToShortsRouteImport } from './routes/gameplay-facecam-to-shorts'
import { Route as InvideoAlternativeRouteImport } from './routes/invideo-alternative'
import { Route as LongVideoToShortVideoRouteImport } from './routes/long-video-to-short-video'
import { Route as LongVideoToShortsRouteImport } from './routes/long-video-to-shorts'
import { Route as OpusClipAlternativeRouteImport } from './routes/opus-clip-alternative'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as SubmagicAlternativeRouteImport } from './routes/submagic-alternative'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TwitchVodToShortsRouteImport } from './routes/twitch-vod-to-shorts'
import { Route as VizardAlternativeRouteImport } from './routes/vizard-alternative'
import { Route as WayinAiAlternativeRouteImport } from './routes/wayin-ai-alternative'
import { Route as YoutubeToShortsRouteImport } from './routes/youtube-to-shorts'
import { Route as AuthSigninRouteImport } from './routes/_auth.signin'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppAccountRouteImport } from './routes/app.account'
import { Route as AppBillingRouteImport } from './routes/app.billing'
import { Route as AppChangePasswordRouteImport } from './routes/app.change-password'
import { Route as AppMediasRouteImport } from './routes/app.medias'
import { Route as AppUsagesRouteImport } from './routes/app.usages'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ToolsToolDotgameplayFacecamToShortsRouteImport } from './routes/tools/tool.gameplay-facecam-to-shorts'
import { Route as ToolsToolDotlongVideoToShortVideoRouteImport } from './routes/tools/tool.long-video-to-short-video'
import { Route as ToolsToolDottwitchVodToShortsRouteImport } from './routes/tools/tool.twitch-vod-to-shorts'
import { Route as ToolsToolDotyoutubeToShortsRouteImport } from './routes/tools/tool.youtube-to-shorts'
import { Route as AppVideosVideoIdRouteImport } from './routes/app.videos.$videoId'
import { Route as AppVideosVideoIdClipsClipIdEditRouteImport } from './routes/app.videos.$videoId_.clips.$clipId.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R2shortAiAlternativeRoute = R2shortAiAlternativeRouteImport.update({
            id: '/2short-ai-alternative',path: '/2short-ai-alternative',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AdcreativeAiAlternativeRoute = AdcreativeAiAlternativeRouteImport.update({
            id: '/adcreative-ai-alternative',path: '/adcreative-ai-alternative',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const GameplayFacecamToShortsRoute = GameplayFacecamToShortsRouteImport.update({
            id: '/gameplay-facecam-to-shorts',path: '/gameplay-facecam-to-shorts',getParentRoute: () => rootRouteImport
          })
const InvideoAlternativeRoute = InvideoAlternativeRouteImport.update({
            id: '/invideo-alternative',path: '/invideo-alternative',getParentRoute: () => rootRouteImport
          })
const LongVideoToShortVideoRoute = LongVideoToShortVideoRouteImport.update({
            id: '/long-video-to-short-video',path: '/long-video-to-short-video',getParentRoute: () => rootRouteImport
          })
const LongVideoToShortsRoute = LongVideoToShortsRouteImport.update({
            id: '/long-video-to-shorts',path: '/long-video-to-shorts',getParentRoute: () => rootRouteImport
          })
const OpusClipAlternativeRoute = OpusClipAlternativeRouteImport.update({
            id: '/opus-clip-alternative',path: '/opus-clip-alternative',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RoadmapRoute = RoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => rootRouteImport
          })
const SubmagicAlternativeRoute = SubmagicAlternativeRouteImport.update({
            id: '/submagic-alternative',path: '/submagic-alternative',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const TwitchVodToShortsRoute = TwitchVodToShortsRouteImport.update({
            id: '/twitch-vod-to-shorts',path: '/twitch-vod-to-shorts',getParentRoute: () => rootRouteImport
          })
const VizardAlternativeRoute = VizardAlternativeRouteImport.update({
            id: '/vizard-alternative',path: '/vizard-alternative',getParentRoute: () => rootRouteImport
          })
const WayinAiAlternativeRoute = WayinAiAlternativeRouteImport.update({
            id: '/wayin-ai-alternative',path: '/wayin-ai-alternative',getParentRoute: () => rootRouteImport
          })
const YoutubeToShortsRoute = YoutubeToShortsRouteImport.update({
            id: '/youtube-to-shorts',path: '/youtube-to-shorts',getParentRoute: () => rootRouteImport
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => AuthRoute
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => AuthRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRoute
          })
const AppBillingRoute = AppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppRoute
          })
const AppChangePasswordRoute = AppChangePasswordRouteImport.update({
            id: '/change-password',path: '/change-password',getParentRoute: () => AppRoute
          })
const AppMediasRoute = AppMediasRouteImport.update({
            id: '/medias',path: '/medias',getParentRoute: () => AppRoute
          })
const AppUsagesRoute = AppUsagesRouteImport.update({
            id: '/usages',path: '/usages',getParentRoute: () => AppRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsToolDotgameplayFacecamToShortsRoute = ToolsToolDotgameplayFacecamToShortsRouteImport.update({
            id: '/tools/gameplay-facecam-to-shorts',path: '/tools/gameplay-facecam-to-shorts',getParentRoute: () => rootRouteImport
          })
const ToolsToolDotlongVideoToShortVideoRoute = ToolsToolDotlongVideoToShortVideoRouteImport.update({
            id: '/tools/long-video-to-short-video',path: '/tools/long-video-to-short-video',getParentRoute: () => rootRouteImport
          })
const ToolsToolDottwitchVodToShortsRoute = ToolsToolDottwitchVodToShortsRouteImport.update({
            id: '/tools/twitch-vod-to-shorts',path: '/tools/twitch-vod-to-shorts',getParentRoute: () => rootRouteImport
          })
const ToolsToolDotyoutubeToShortsRoute = ToolsToolDotyoutubeToShortsRouteImport.update({
            id: '/tools/youtube-to-shorts',path: '/tools/youtube-to-shorts',getParentRoute: () => rootRouteImport
          })
const AppVideosVideoIdRoute = AppVideosVideoIdRouteImport.update({
            id: '/videos/$videoId',path: '/videos/$videoId',getParentRoute: () => AppRoute
          })
const AppVideosVideoIdClipsClipIdEditRoute = AppVideosVideoIdClipsClipIdEditRouteImport.update({
            id: '/videos/$videoId_/clips/$clipId/edit',path: '/videos/$videoId/clips/$clipId/edit',getParentRoute: () => AppRoute
          })





const AuthRouteChildren = {
  AuthSigninRoute: AuthSigninRoute,AuthSignupRoute: AuthSignupRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,AppBillingRoute: AppBillingRoute,AppChangePasswordRoute: AppChangePasswordRoute,AppMediasRoute: AppMediasRoute,AppUsagesRoute: AppUsagesRoute,AppIndexRoute: AppIndexRoute,AppVideosVideoIdRoute: AppVideosVideoIdRoute,AppVideosVideoIdClipsClipIdEditRoute: AppVideosVideoIdClipsClipIdEditRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R2shortAiAlternativeRoute: R2shortAiAlternativeRoute,AuthRoute: AuthRouteWithChildren,AdcreativeAiAlternativeRoute: AdcreativeAiAlternativeRoute,AppRoute: AppRouteWithChildren,GameplayFacecamToShortsRoute: GameplayFacecamToShortsRoute,InvideoAlternativeRoute: InvideoAlternativeRoute,LongVideoToShortVideoRoute: LongVideoToShortVideoRoute,LongVideoToShortsRoute: LongVideoToShortsRoute,OpusClipAlternativeRoute: OpusClipAlternativeRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RoadmapRoute: RoadmapRoute,SubmagicAlternativeRoute: SubmagicAlternativeRoute,TermsOfServiceRoute: TermsOfServiceRoute,TwitchVodToShortsRoute: TwitchVodToShortsRoute,VizardAlternativeRoute: VizardAlternativeRoute,WayinAiAlternativeRoute: WayinAiAlternativeRoute,YoutubeToShortsRoute: YoutubeToShortsRoute,BlogSlugRoute: BlogSlugRoute,ToolsToolDotgameplayFacecamToShortsRoute: ToolsToolDotgameplayFacecamToShortsRoute,ToolsToolDotlongVideoToShortVideoRoute: ToolsToolDotlongVideoToShortVideoRoute,ToolsToolDottwitchVodToShortsRoute: ToolsToolDottwitchVodToShortsRoute,ToolsToolDotyoutubeToShortsRoute: ToolsToolDotyoutubeToShortsRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)